import { Col, Grid, Row } from "@nextui-org/react";
import { ReleaseFunds, ReleaseWeth, Releaseable } from ".";

export function Release() {
  return (
    <>
      <Releaseable />
      {/* <Grid.Container gap={4}> */}
      <Row justify="center" gap={1}>
        <Col>
          <ReleaseFunds />
        </Col>
        <Col>
          <ReleaseWeth />
        </Col>
      </Row>
      {/* </Grid.Container> */}
    </>
  );
}
